//if you create a new route, you should add it to the "routes" array below

export const ROUTES = {
  LOGIN: '/login',
  SIGNUP: '/signup',
  INSIGHTS: '/',
  INSIGHTS_ALIAS: '/insights',
  DASHBOARD: '/dashboard',

  PROJECTS: '/projects',
  CREATE_PROJECTS: '/projects/create',
  SINGLE_PROJECT: '/projects/:project_id',
  TEAMS: '/teams',
  SINGLE_TEAM: '/teams/:team_id',
  PLANS: '/plans',
  SETTINGS: '/settings',
  PERSONAL_INFO: '/settings/personal-information',
  INTEGRATIONS: '/settings/integrations',
  SLACK_INTEGRATION: '/settings/integrations/slack',
  OPENAI_INTEGRATION: '/settings/integrations/openai',
  JIRA_INTEGRATION: '/settings/integrations/jira',
  PERMISSIONS: '/settings/permissions',
};

export const allRoutes = [
  { name: 'login', link: '/login' },
  { name: 'signup', link: '/signup' },
  { name: 'projects', link: '/projects' },
  { name: 'projects', link: '/projects/:projectId' },
  { name: 'projects', link: '/projects/:projectId/task/:taskId' },
  { name: 'teams', link: '/teams' },
  { name: 'teams', link: '/teams/:team_id' },
  { name: 'plans', link: '/plans' },
  { name: 'integrations', link: '/integrations' },
  { name: 'integrations', link: '/integrations/Slack' },
  { name: 'integrations', link: '/integrations/OpenAI' },
  { name: 'integrations', link: '/integrations/Jira' },

  // { name: 'permissions', link: '/permissions' },
  { name: 'settings', link: '/settings' },
  { name: 'settings', link: '/settings/integrations' },
  { name: 'settings', link: '/settings/integrations/slack' },
  { name: 'settings', link: '/settings/integrations/openai' },
  { name: 'settings', link: '/settings/integrations/jira' },
  { name: 'settings', link: '/settings/permissions' },
  { name: 'settings', link: '/settings/personal-information' },
  { name: 'insights', link: '/' },
  { name: 'insights', link: '/insights' },
];

// Pre-computed regex patterns for dynamic route matching (computed once at module load)
export const routeRegexMap = new Map(
  allRoutes.map((route) => [
    route.link,
    new RegExp(`^${route.link.replace(/:\w+/g, '[^/]+')}$`),
  ])
);
